import React from 'react'
import PropTypes from 'prop-types'
import { SocialLoginTypingTemplate } from '../../templates/SocialLoginTypingTemplate/SocialLoginTypingTemplate'
import { FocusHeader } from '@olxbr/ds-web'

export const SocialLoginTypingPage = ({ token, email, onPhoneNotValidated, from }) => (
  <>
    <FocusHeader />
    <SocialLoginTypingTemplate
      token={token}
      email={email}
      onPhoneNotValidated={onPhoneNotValidated}
      from={from}
    />
  </>
)

SocialLoginTypingPage.propTypes = {
  token: PropTypes.string,
  email: PropTypes.string,
  onPhoneNotValidated: PropTypes.func,
  from: PropTypes.string,
}
